/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { withNamespaces } from "react-i18next";

// Components
import Select from "react-select";

// Styles
import styles from "./MultiSelect.css";

class MultiSelect extends Component {
  state = {
    allOption: {
      label: this.props.t(`modules.localization.register.authenticated.common.select.selectAll`),
      value: `*`
    }
  };

  componentDidUpdate(prevProps) {
    const { input, options, t } = this.props;
    if (prevProps.input.value !== input.value) {
      if (input.value.length === options.length)
        this.setState((prevState) => ({
          allOption: {
            ...prevState.allOption,
            label: t(`modules.localization.register.authenticated.common.select.unselectAll`)
          }
        }));
      else
        this.setState((prevState) => ({
          allOption: {
            ...prevState.allOption,
            label: t(`modules.localization.register.authenticated.common.select.selectAll`)
          }
        }));
    }
  }

  handleOnBlur = (event) => {
    // Fix to solve issue that happen on mobile devices
    event.preventDefault();
  };

  render() {
    const {
      disabled,
      errorMessage,
      input,
      label,
      meta,
      allowSelectAll,
      options,
      ...rest
    } = this.props;
    const { allOption } = this.state;

    return (
      <>
        <label className="label">{label}</label>
        {allowSelectAll ? (
          <Select
            options={[allOption, ...options]}
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            isDisabled={disabled}
            isMulti
            isSearchable={false}
            styles={styles(meta.error && meta.touched)}
            theme={(theme) => ({
              ...theme,
              borderRadius: 0,
              color: { ...theme.colors, primary: `#258ffd` }
            })}
            {...rest}
            {...input}
            onBlur={this.handleOnBlur}
            onChange={(selected) => {
              if (
                selected !== null &&
                selected.length > 0 &&
                selected[selected.length - 1].value === allOption.value &&
                !(input.value && input.value.length === options.length)
              ) {
                return input.onChange(options);
              }
              if (
                selected !== null &&
                selected.length > 0 &&
                selected[selected.length - 1].value === allOption.value &&
                input.value &&
                input.value.length === options.length
              ) {
                return input.onChange([]);
              }
              return input.onChange(selected);
            }}
          />
        ) : (
          <Select
            options={options}
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            isDisabled={disabled}
            isMulti
            isSearchable={false}
            styles={styles(meta.error && meta.touched)}
            theme={(theme) => ({
              ...theme,
              borderRadius: 0,
              color: { ...theme.colors, primary: `#258ffd` }
            })}
            {...rest}
            {...input}
            onBlur={this.handleOnBlur}
          />
        )}

        <em className="invalid" style={{ height: 30, minHeight: 30 }}>
          {meta.error && meta.touched && errorMessage} &nbsp;
        </em>
      </>
    );
  }
}

MultiSelect.propTypes = {
  allowSelectAll: PropTypes.bool,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  meta: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired
};

export default withNamespaces()(MultiSelect);
